import CountDown from '@/components/CountDown';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import Input from '@/components/UI/Input';
import { message } from '@/components/UI/Message';
import { ENGLISH_LANG, newVersionRegion, rpcMap } from '@/constants';
import seoconfig from '@/seoconfig/forget';
import { checkAccountIsExist, checkHumanMachine, getVerifyCode, resetPassword, verificationCode } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { Form } from 'antd';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import debounce from 'lodash/debounce';
import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './index.module.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { redirectTo404 } from '@/utils';
import { sendPostErrorMonitoring } from '@/appComps/ErrorMonitoringCommon/api';

export default function Forget({ lang, SEO }: any) {
    const RESEND_GAP = 60;
    const [form] = Form.useForm();
    const recaptchaRef = React.useRef();
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;
    const { useRouter, useLang, isMobile } = useGlobal();
    const { locale } = useRouter();
    const [inputClass, SetInputClass] = useState({
        activeFirst: '',
        name: '',
    });
    const [passwordClass, setPasswordClass] = useState({
        activePassword: '',
        name: '',
    });
    const [confirmPasswordClass, setConfirmPasswordClass] = useState({
        activeConfirmPassword: '',
        name: '',
    });
    const [step, setStep] = useState({ first: true, second: false, third: false, fourth: false });
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [emailValidating, setEmailValidating] = useState(''); // 'success' 'warning' 'error' 'validating'
    const [isResendLoading, setIsResendLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [counts, setCounts] = useState(RESEND_GAP);
    const [errorTip, setErrorTip] = useState('');
    const [isErrorTip, setIsErrorTip] = useState(false);
    const router = useRouter();
    const { t } = useLang('shared');
    const { t: forgetLang } = useLang('forget');

    const isNewVersionRegion = newVersionRegion(locale);
    const [codeForm] = Form.useForm();
    const [emailCodeInputStatus, setEmailCodeInputStatus] = useState(0);
    const [resendCode, setResendCode] = useState(RESEND_GAP);
    const [formData, setFormData] = useState<Record<string, any>>({});
    const [humanCheck, setHumanCheck] = useState(false);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [code, setCode] = useState('');
    const [confirmForm] = Form.useForm();
    const [sendFlag, setSendFlag] = useState('');

    const [passwordValidating, setPasswordValidating] = useState(''); // 'success' 'warning' 'error' 'validating'
    const [confirmPasswordValidating, setConfirmPasswordValidating] = useState(''); // 'success' 'warning' 'error' 'validating'
    const [passwordValid, setPasswordValid] = useState({
        password: false,
        confirmPassword: false,
    });
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];
    // send validate email
    const handleSendEmail = async () => {
        const params = {
            scene: 'WEB_RESET_PASSWORD',
            account: email,
        };

        setIsResendLoading(true);

        try {
            const res: any = await getVerifyCode(params, locale);
            setIsResendLoading(false);
            if (res.code === '0') {
                message.success(t('logintips.site_login_forgot_password_check_email'));
            } else {
                message.error(res.message);
            }
            setCounts(3);
            setIsDisabled(true);
        } catch (err) {
            setIsResendLoading(false);
            console.log(err);
        }
    };

    // 校验邮箱
    const validateEmail = () => {
        return {
            validator: async (_: any, value: any) => {
                setEmail(value);

                const regx = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;

                setIsErrorTip(false);

                if (!value) {
                    setEmailValidating('error');
                    return Promise.reject(t('logintips.site_login_tip_email_empty'));
                }

                if (!regx.test(value)) {
                    setEmailValidating('error');
                    return Promise.reject(t('logintips.site_login_tip_email_format_incorrect'));
                }

                setEmailValidating('validating');

                try {
                    const res: any = await checkAccountIsExist({ email: value });

                    if (res.code === '0') {
                        setEmailValidating('success');
                        setEmail(value);
                    } else if (res.code === '1003') {
                        setEmailValidating('error');
                        return Promise.reject(t('logintips.site_login_tip_email_not_registered'));
                    }
                    return Promise.resolve();
                } catch (err) {
                    console.log('email validator failed');
                    setEmailValidating('');
                }
            },
        };
    };

    // 校验密码
    const validatePassword = () => {
        return {
            validator(_: any, value: any) {
                // const regx = /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                // const regx = isNewVersionRegion
                //     ? /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^0-9A-Za-z\f\n\r\t\v])(?=^[0-9A-Za-z\S]{15,32}$).*$/
                //     : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                const regx = isNewVersionRegion
                    ? /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-])\S{15,32}$/
                    : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                if (!value) {
                    setPasswordValidating('error');

                    return Promise.reject(t('logintips.site_login_tip_password_empty'));
                }
                if (!regx.test(value)) {
                    setPasswordValidating('error');

                    return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
                }
                setPasswordValidating('success');

                setPasswordValid({
                    ...passwordValid,
                    ...{ password: true },
                });
            },
        };
    };

    // 校验确认密码
    const validateConfirmPassword = ({ getFieldValue }: any) => {
        return {
            validator(_: any, value: any) {
                const regx = isNewVersionRegion
                    ? /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-])\S{15,32}$/
                    : /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                const pwd = getFieldValue('password');

                setIsErrorTip(false);
                if (!value) {
                    setConfirmPasswordValidating('error');
                    return Promise.reject(t('logintips.site_login_tip_password_empty'));
                }

                if (!regx.test(value)) {
                    setConfirmPasswordValidating('error');
                    return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
                }

                if (pwd !== value) {
                    setConfirmPasswordValidating('error');
                    return Promise.reject(t('logintips.site_login_tip_password_twice_inconsistent'));
                }
                setConfirmPasswordValidating('success');

                setPasswordValid({
                    ...passwordValid,
                    ...{ confirmPassword: true },
                });
            },
        };
    };

    // click next
    const onFinish = async (values: any) => {
        const params = {
            scene: 'WEB_RESET_PASSWORD', //校验验证码
            account: values.email,
        };

        setLoading(true);

        try {
            const res: any = await getVerifyCode(params, locale);
            setLoading(false);
            if (res.code === '0') {
                setEmail(values.email);
                if (isNewVersionRegion) {
                    setStep({ first: false, second: true, third: false, fourth: false });
                }
                setErrorTip('');
                setIsErrorTip(false);
            } else {
                sendPostErrorMonitoring(locale, {
                    error_type_1: 'user-error',
                    error_type_2: 'forget',
                    error_content_1: res.code,
                    error_content_2: res.message,
                });
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);

            sendPostErrorMonitoring(locale, {
                error_type_1: 'user-error',
                error_type_2: 'forget',
                error_content_1: `error:${err}`,
            });
        }
    };

    // router jump
    const goLogin = (text: string) => {
        signupCookie({ sector_name: text, entry_position: 1 });
        router.push({ pathname: '/login' });
    };

    const onBlurInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: '',
                    name: value,
                });
            }
        }
    };

    const onFocusInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'email') {
                SetInputClass({
                    activeFirst: 'active',
                    name: value,
                });
            }
        }
    };

    const onFocusPassword = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'password') {
                setPasswordClass({
                    activePassword: 'active',
                    name: value,
                });
            }
        }
    };
    const onBlurPassword = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'password') {
                setPasswordClass({
                    activePassword: '',
                    name: value,
                });
            }
        }
    };
    const onFocusConfirmPassword = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'confirmPassword') {
                setConfirmPasswordClass({
                    activeConfirmPassword: 'active',
                    name: value,
                });
            }
        }
    };
    const onBlurConfirmPassword = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'confirmPassword') {
                setConfirmPasswordClass({
                    activeConfirmPassword: '',
                    name: value,
                });
            }
        }
    };

    // 发送邮件验证码
    const sendEmailCode = async () => {
        const account = form.getFieldValue('email');
        const recaptchaRes = humanCheck ? { recaptchaResponse } : {};
        const obj = { scene: 'WEBSITE_RESET_PASSWORD', account, ...recaptchaRes };
        setLoading(true);
        try {
            const res: any = await getVerifyCode(obj, locale);
            setLoading(false);
            if (res.code === '0') {
                setStep({ first: false, second: true, third: false, fourth: false });
                setCounts(RESEND_GAP);
            } else if (res.code === '2017') {
                setHumanCheck(true);
                setIsErrorTip(true);
                setErrorTip(res.message);
            } else {
                setIsErrorTip(true);
                setErrorTip(res.message);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) {
            return;
        }

        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFields([
            {
                name: 'recaptchaResponse',
                value: captchaCode,
                errors: [],
            },
        ]);
    };
    // 人机校验 end

    // 校验验证码是否正确
    const handleCheckCode = async () => {
        const account = form.getFieldValue('email');
        const resetCode = codeForm.getFieldValue('code');
        const data = {
            account,
            code: resetCode,
            scene: 'WEBSITE_RESET_PASSWORD',
        };
        setLoading(true);

        try {
            const res: any = await verificationCode(data, locale);
            setLoading(false);
            if (res.code === '0') {
                setStep({ first: false, second: false, third: true, fourth: false });
                setErrorTip('');
                setIsErrorTip(false);
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const onNewFinish = async (values: any) => {
        const confirmData = confirmForm.getFieldsValue();
        const data = {
            code: code || '',
            email: email || '',
            password: Base64.stringify(Utf8.parse(confirmData.password)),
            confirmPassword: Base64.stringify(Utf8.parse(confirmData.confirmPassword)),
            verificationScene: 'WEBSITE_RESET_PASSWORD',
        };

        try {
            setLoading(true);

            const res: any = await resetPassword(data);

            if (res.code === '0') {
                setStep({ first: false, second: false, third: false, fourth: true });
                setSendFlag('');
                setFormData({});
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    };

    const handleBeforeSendCode = async (flag: string) => {
        setSendFlag(flag);
        if (humanCheck && recaptchaResponse) {
            sendEmailCode();
            return;
        }
        const params = {
            functionName: 'forgetPassword',
            account: email,
        };
        setLoading(true);

        try {
            const res = await checkHumanMachine(params);
            setLoading(false);

            if (res.code === '0') {
                setHumanCheck(res.data);
                if (!res.data) {
                    sendEmailCode();
                }
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }

            return;
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    return (
        <PageLayout style={{ background: '#f8f8f8' }}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={router.asPath.substr(1)} />
            <h1 className="visuallyhidden">EcoFlow</h1>
            <div className={`${css.login}`}>
                <div className="login-wrap">
                    <div className="login-box">
                        {step.first && (
                            <>
                                <h2>
                                    {isMobile ? (
                                        <div className="img-wrapper"></div>
                                    ) : (
                                        <Image src="/icons/logo.svg" alt={t('logintips.logo')} width={140} height={15} />
                                    )}
                                </h2>
                                <p className="fo-title1">{lang.site_login_forgot_password_retrieve_password}</p>
                            </>
                        )}

                        {step.second && !isMobile && (
                            <>
                                <h2>
                                    <Image src="/icons/logo.svg" alt={t('logintips.logo')} width={140} height={15} />
                                </h2>
                            </>
                        )}
                        {step.second && isNewVersionRegion && (
                            <div>
                                <p className="email-code-recovery-title">{t('logintips.site_forgot_account_recovery')}</p>
                                <p className="email-code-recovery-desc">
                                    {t('logintips.site_forgot_account_recovery_tip_before')}
                                    {email}
                                    {t('logintips.site_forgot_account_recovery_tip_after')}
                                </p>
                            </div>
                        )}
                        {step.third && !isMobile && (
                            <h2>
                                <Image src="/icons/logo.svg" alt={t('logintips.logo')} width={140} height={15} />
                            </h2>
                        )}
                        {step.third && isNewVersionRegion && <p className="create-password-title">{t('logintips.site_forget_account_create_title')}</p>}

                        {step.first && (
                            <>
                                <Form name="normal_login" form={form} className="login-form" initialValues={{ remember: true }}>
                                    <div className="inputItem">
                                        <label className={inputClass.activeFirst == 'active' ? 'active' : ''}>{lang.site_login_email}</label>
                                        <Form.Item
                                            name="email"
                                            label="Email"
                                            validateStatus={emailValidating}
                                            rules={[validateEmail]}
                                            shouldUpdate
                                            validateTrigger="onBlur"
                                        >
                                            <Input
                                                className="default-input "
                                                onFocus={(e: any) => onFocusInput(e, 'email')}
                                                onBlur={(e: any) => onBlurInput(e, 'email')}
                                                aria-label={t('logintips.email')}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="inputItem">
                                        {/*人机校验 */}
                                        {isNewVersionRegion && humanCheck && sendFlag === 'step1' && (
                                            <Form.Item
                                                name="recaptchaResponse"
                                                rules={[
                                                    {
                                                        validator() {
                                                            if (recaptchaResponse) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                        },
                                                    },
                                                ]}
                                                style={{ marginTop: '40px', marginBottom: '32px' }}
                                            >
                                                <div className="g-recaptcha">
                                                    {/* @ts-ignore */}
                                                    <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                                </div>
                                            </Form.Item>
                                        )}
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>

                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn large login-form-button"
                                            loading={loading}
                                            aria-label={lang.site_login_forgot_password_next}
                                            disabled={(humanCheck && !recaptchaResponse) || emailValidating !== 'success'}
                                            onClick={async () => {
                                                setFormData({
                                                    ...formData,
                                                    ...form.getFieldsValue(),
                                                });

                                                if (isNewVersionRegion) {
                                                    // 先判断是否需要人机校验
                                                    handleBeforeSendCode('step1');
                                                } else {
                                                    await onFinish({});
                                                }
                                            }}
                                        >
                                            {lang.site_login_forgot_password_next}{' '}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </>
                        )}

                        {step.second && isNewVersionRegion && (
                            <>
                                <Form name="normal_login" form={codeForm} className="login-form" initialValues={{ remember: true }}>
                                    <div className="inputItem">
                                        <label className={emailCodeInputStatus !== 0 ? 'active' : ''}>{lang.site_login_email_code}</label>
                                        <Form.Item name="code" label="Code" shouldUpdate validateTrigger="onBlur">
                                            <Input
                                                className="default-input "
                                                aria-label={t('logintips.email_code')}
                                                onFocus={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                }}
                                                onBlur={(e: any) => {
                                                    const val = e.target.value;
                                                    setEmailCodeInputStatus(val ? 2 : 0);
                                                }}
                                                onChange={debounce((e) => {
                                                    setErrorTip('');
                                                    setIsErrorTip(false);
                                                    const val = e.target.value;
                                                    setCode(e.target.value);
                                                    setEmailCodeInputStatus(val ? 2 : 1);
                                                }, 300)}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="inputItem">
                                        {/*人机校验 */}
                                        {isNewVersionRegion && humanCheck && sendFlag === 'step2' && (
                                            <Form.Item
                                                name="recaptchaResponse"
                                                rules={[
                                                    {
                                                        validator() {
                                                            if (recaptchaResponse) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(t('logintips.site_login_tip_perform_verification'));
                                                        },
                                                    },
                                                ]}
                                                style={{ marginTop: '40px', marginBottom: '32px' }}
                                            >
                                                <div className="g-recaptcha">
                                                    {/* @ts-ignore */}
                                                    <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                                </div>
                                            </Form.Item>
                                        )}
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>

                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn large login-form-button"
                                            loading={loading}
                                            disabled={emailCodeInputStatus !== 2}
                                            aria-label={lang.site_login_forgot_password_next}
                                            onClick={async () => {
                                                setFormData({
                                                    ...formData,
                                                    ...codeForm.getFieldsValue(),
                                                });
                                                await handleCheckCode();
                                            }}
                                        >
                                            {lang.site_login_forgot_password_next}{' '}
                                        </Button>
                                        <Button
                                            type="link"
                                            disabled={resendCode !== 0}
                                            className="resend-code"
                                            onClick={() => {
                                                // 重新发送验证码
                                                // sendEmailCode();
                                                handleBeforeSendCode('step2');
                                                setResendCode(RESEND_GAP);
                                            }}
                                        >
                                            {lang.site_resend_code}
                                            <CountDown
                                                sec={resendCode}
                                                secUnit={t('secondUnit')}
                                                onFinish={() => {
                                                    setResendCode(0);
                                                }}
                                            />
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </>
                        )}
                        {/*send email */}
                        {step.second && !isNewVersionRegion && (
                            <>
                                <p className="email-confirm">{t('logintips.site_login_forgot_reset_check_email')}</p>
                                <p className="reset-email-success-text gray">{t('logintips.site_login_forgot_password_check_email')}</p>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="black-btn large login-form-button login-form-button2"
                                    loading={false}
                                    aria-label={lang.site_login_log_email_account}
                                    onClick={() => goLogin(lang.site_login_log_email_account)}
                                >
                                    {lang.site_login_log_email_account}{' '}
                                </Button>

                                <Button
                                    type="primary"
                                    className="black-btn large resend-email-btn"
                                    onClick={handleSendEmail}
                                    disabled={isDisabled}
                                    loading={isResendLoading}
                                    aria-label={lang.site_login_forgot_password_reset_email}
                                >
                                    {lang.site_login_forgot_password_reset_email}{' '}
                                    <CountDown
                                        sec={counts}
                                        onFinish={() => {
                                            setIsDisabled(false);
                                            setCounts(0);
                                        }}
                                    />
                                </Button>
                            </>
                        )}

                        {step.third && isNewVersionRegion && (
                            <>
                                <Form name="normal_login" form={confirmForm} className="login-form" initialValues={{ remember: true }}>
                                    <div className="inputItem">
                                        <label className={passwordClass.activePassword == 'active' ? 'active' : ''}>{t('logintips.newPwd')}</label>
                                        <Form.Item
                                            name="password"
                                            label={t('logintips.newPwd')}
                                            validateStatus={passwordValidating}
                                            rules={[validatePassword]}
                                            shouldUpdate
                                            validateTrigger="onBlur"
                                        >
                                            <Input.Password
                                                type="password"
                                                className="default-input "
                                                aria-label={t('logintips.email_code')}
                                                onFocus={(e: any) => onFocusPassword(e, 'password')}
                                                onBlur={(e: any) => onBlurPassword(e, 'password')}
                                                onChange={debounce((e) => {
                                                    setErrorTip('');
                                                    setIsErrorTip(false);
                                                }, 300)}
                                            />
                                        </Form.Item>

                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>
                                    <div className="inputItem">
                                        <label className={confirmPasswordClass.activeConfirmPassword == 'active' ? 'active' : ''}>
                                            {t('logintips.confirmNewPwd')}
                                        </label>
                                        <Form.Item
                                            name="confirmPassword"
                                            dependencies={['password']}
                                            label={t('logintips.confirmNewPwd')}
                                            validateStatus={confirmPasswordValidating}
                                            rules={[validateConfirmPassword]}
                                            shouldUpdate
                                            validateTrigger="onBlur"
                                            style={{ marginTop: '40px' }}
                                        >
                                            <Input.Password
                                                type="password"
                                                className="default-input "
                                                aria-label={t('logintips.email_code')}
                                                onFocus={(e: any) => onFocusConfirmPassword(e, 'confirmPassword')}
                                                onBlur={(e: any) => onBlurConfirmPassword(e, 'confirmPassword')}
                                                onChange={debounce((e) => {
                                                    setErrorTip('');
                                                    setIsErrorTip(false);
                                                }, 300)}
                                            />
                                        </Form.Item>
                                        {isErrorTip && <div className="error-tip">{errorTip}</div>}
                                    </div>

                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn large login-form-button"
                                            loading={loading}
                                            disabled={!(passwordValid.password && passwordValid.confirmPassword)}
                                            aria-label={t('logintips.Submit')}
                                            onClick={async () => {
                                                setFormData({
                                                    ...formData,
                                                    ...confirmForm.getFieldsValue(),
                                                });
                                                await onNewFinish({});
                                            }}
                                        >
                                            {t('logintips.Submit')}{' '}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </>
                        )}

                        {step.fourth && isNewVersionRegion && (
                            <div>
                                <h2>
                                    <Image src="/icons/reset_pwd_success.svg" width={72} height={72} alt={t('logintips.site_forget_account_success')} />
                                </h2>
                                <p className="forget-password-success-title">{t('logintips.site_forget_account_success')}</p>
                                <Button
                                    type="primary"
                                    className="black-btn large forget-password-success-btn"
                                    loading={loading}
                                    aria-label={t('logintips.site_forget_account_success_btn_text')}
                                    onClick={() => goLogin(lang.site_forget_got_it)}
                                >
                                    {lang.site_forget_got_it}{' '}
                                </Button>
                                <div className="redirect-tip-box">
                                    {forgetLang.rich('redirect_tip', {
                                        highLight: (text: string) => (
                                            <span>
                                                {text}
                                                <CountDown
                                                    sec={3}
                                                    onFinish={() => {
                                                        goLogin(text);
                                                    }}
                                                />
                                            </span>
                                        ),
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const { locale } = context;
    if (['cn'].includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
